module.exports = __webpack_public_path__ + "static/avril-do-what-i-want-ce74e7409325691fd1d3e66826498c3c.gif";